let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dO8kh")).then(() => parcelRequire('eLbLS'));